var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchTab"},_vm._l((_vm.tabList),function(el){return _c('span',{key:el.name,class:el.isActive ? 'active' : '',on:{"click":function($event){return _vm.setActive(el)}}},[_vm._v(_vm._s(el.name))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }